import { WsError } from '@gem/modules/wsClient/wsErrors';

export enum WsAppErrorCode {
  BadData = 400,
}

export class UntrustedWsAppApiError extends WsError {
  constructor(public code: WsAppErrorCode, public message: string) {
    super(code, message);
  }
}
